import { render, staticRenderFns } from "./VxViewUpload.vue?vue&type=template&id=0038d7d9&"
import script from "./VxViewUpload.vue?vue&type=script&lang=js&"
export * from "./VxViewUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports